// extracted by mini-css-extract-plugin
export default {"HeaderCell":"HeaderCell_HeaderCell__DtlHQ","HeaderCell__unsorted":"HeaderCell_HeaderCell__unsorted__LMMks"};